import { ReactNode } from "react";

import { Box, Hidden, Icon, Step as MuiStep, StepLabel, Stepper, Theme, Typography } from "@mui/material";
import { SxProps } from "@mui/system";
import { CheckBoxOutlined, CreateOutlined, ExitToAppOutlined } from "@mui/icons-material";

import { Mode, Step } from "../hooks/useInputForm";

const items = [
  {
    step: Step.INPUT,
    labelNew: "Въвеждане",
    labelEdit: "Редакция",
    icon: <CreateOutlined sx={{ fontSize: "32px" }} />,
  },
  {
    step: Step.PREVIEW,
    labelNew: "Преглед",
    labelEdit: "Преглед",
    icon: <CheckBoxOutlined sx={{ fontSize: "32px" }} />,
  },
  {
    step: Step.SUCCESS,
    labelNew: "Вписване",
    labelEdit: "Вписване",
    icon: <ExitToAppOutlined sx={{ fontSize: "32px" }} />,
  },
];

function StepIcon({ icon, active }: { icon: ReactNode; active: boolean }) {
  const style = (theme: Theme): SxProps => {
    return {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "50%",
      width: 65,
      height: 65,
      color: theme.palette.common.white,
      backgroundColor: active ? theme.palette.secondary.main : theme.palette.grey[300],
    };
  };

  return <Icon sx={(theme) => ({ ...style(theme) })}>{icon}</Icon>;
}

type LinearStepperProps = { step: Step; mode: Mode };

export default function LinearStepper({ step, mode }: LinearStepperProps) {
  return (
    <Box>
      <Stepper sx={{ mx: "-10px", my: 0 }}>
        {items.map(({ labelNew, labelEdit, icon, step: itemStep }, index) => (
          <MuiStep key={index}>
            <StepLabel StepIconComponent={StepIcon} StepIconProps={{ icon: icon, active: itemStep === step }}>
              <Hidden mdDown>
                <Typography variant="button">{`${index + 1}. ${mode === Mode.NEW ? labelNew : labelEdit}`}</Typography>
              </Hidden>
            </StepLabel>
          </MuiStep>
        ))}
      </Stepper>
    </Box>
  );
}
